import { render, staticRenderFns } from "./SaveCsv.vue?vue&type=template&id=a4e8006a&"
import script from "./SaveCsv.vue?vue&type=script&lang=js&"
export * from "./SaveCsv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports